function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { InfaceEnv } from '@inface-sdk/common';
import { stampMediator } from '../mediator';
var INFACE_ENV_KEY = {
  LOCALE: 'locale'
};
var FEATURE_ENUM = {
  PAYMENT: 'payment',
  PURCHASE_HISTORY: 'purchase_history'
};
var LOCALE_ENUM = {
  EN: 'en',
  KO: 'ko',
  get DEFAULT() {
    return this.EN;
  },
  get FALLBACK() {
    return this.KO;
  }
};
var MARKET_ENUM = {
  KRPC: 'KRPC',
  JPPC: 'JPPC',
  TOY: 'TOY',
  ARENA: 'ARENA'
};
var PRICE_CURRENCY = {
  USD: 'USD',
  KRW: 'KRW',
  JPY: 'JPY',
  TOY: 'TOY'
};
var PRICE_LOCALE_UNIT = _defineProperty(_defineProperty(_defineProperty({}, PRICE_CURRENCY.USD, '$'), PRICE_CURRENCY.KRW, '₩'), PRICE_CURRENCY.JPY, '¥');
function _isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}
function getLocale() {
  var infaceLocale = InfaceEnv.value[INFACE_ENV_KEY.LOCALE];
  var locale = infaceLocale && infaceLocale.replace('-', '_').split('_')[0];
  return locale || LOCALE_ENUM.DEFAULT;
}
function getPriceUnit(currency) {
  return PRICE_LOCALE_UNIT[currency];
}
function getDefaultLocale() {
  return LOCALE_ENUM.DEFAULT;
}
function getFallbackLocale() {
  return LOCALE_ENUM.FALLBACK;
}
function getMarketFromWebToken(webToken) {
  var signature = webToken.split(':')[4];
  if (!signature) {
    if (typeof window === 'undefined') {
      signature = 'ANA'; // for arena
    } else {
      var _window$inface;
      console.warn('web token does not have, use the country value by browser value');
      var country = InfaceEnv.value.locale || ((_window$inface = window.inface) === null || _window$inface === void 0 || (_window$inface = _window$inface.common) === null || _window$inface === void 0 || (_window$inface = _window$inface.InfaceEnv) === null || _window$inface === void 0 || (_window$inface = _window$inface.value) === null || _window$inface === void 0 ? void 0 : _window$inface.locale);
      if (!country) {
        signature = 'ANA';
      } else if (/kr/i.test(country)) {
        signature = 'KPF';
      } else if (/ja/i.test(country)) {
        signature = 'JPF';
      } else {
        signature = 'ANA';
      }
    }
  }
  switch (signature) {
    case 'KPF':
      return MARKET_ENUM.KRPC;
    case 'JPF':
      return MARKET_ENUM.JPPC;
    case 'TOY':
      return MARKET_ENUM.TOY;
    default:
      return MARKET_ENUM.ARENA;
  }
}
function _getArenaCurrency(_x, _x2) {
  return _getArenaCurrency2.apply(this, arguments);
}
function _getArenaCurrency2() {
  _getArenaCurrency2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(webToken, gid) {
    var param;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          param = {
            token: webToken,
            token_type: 'IAS_WEB_TOKEN'
          };
          _context.prev = 1;
          return _context.abrupt("return", stampMediator.getArenaCurrency({
            param: param,
            header: {
              gid: gid
            }
          }));
        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](1);
          console.error(_context.t0);
          return _context.abrupt("return", {
            error: true,
            object: _context.t0,
            message: 'cannot fetch for arena currency info'
          });
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 5]]);
  }));
  return _getArenaCurrency2.apply(this, arguments);
}
function getCurrency(_x3, _x4) {
  return _getCurrency.apply(this, arguments);
}
function _getCurrency() {
  _getCurrency = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(webToken, gid) {
    var market, currency;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          market = getMarketFromWebToken(webToken);
          _context2.t0 = market;
          _context2.next = _context2.t0 === MARKET_ENUM.KRPC ? 4 : _context2.t0 === MARKET_ENUM.JPPC ? 5 : _context2.t0 === MARKET_ENUM.TOY ? 6 : 7;
          break;
        case 4:
          return _context2.abrupt("return", PRICE_CURRENCY.KRW);
        case 5:
          return _context2.abrupt("return", PRICE_CURRENCY.JPY);
        case 6:
          return _context2.abrupt("return", PRICE_CURRENCY.TOY);
        case 7:
          _context2.prev = 7;
          _context2.next = 10;
          return _getArenaCurrency(webToken, gid);
        case 10:
          currency = _context2.sent;
          return _context2.abrupt("return", currency && currency.error ? PRICE_CURRENCY.USD : currency);
        case 14:
          _context2.prev = 14;
          _context2.t1 = _context2["catch"](7);
          console.warn('cannot got a currency information ', _context2.t1);
        case 17:
          return _context2.abrupt("return", PRICE_CURRENCY.USD);
        case 18:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[7, 14]]);
  }));
  return _getCurrency.apply(this, arguments);
}
function numberWithCommas(x) {
  if (x && typeof x === 'number') {
    if (x % 1 === 0) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return x;
  }
  return '999,999,999';
}
function getLocalizedPrice(currency, priceMap) {
  if (!(currency in priceMap)) {
    throw new Error("have no ".concat(currency, " data in ").concat(JSON.stringify(priceMap)));
  }
  var price = priceMap[currency];
  return "".concat(PRICE_LOCALE_UNIT[currency]).concat(numberWithCommas(price));
}
function getLocalizedValue(map) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (_isEmptyObject(map)) {
    return defaultValue ? "empty: ".concat(defaultValue) : defaultValue;
  }
  var locale = getLocale();
  var rv = map[locale];
  if (typeof rv === 'undefined') {
    var _Object$entries$ = _slicedToArray(Object.entries(map)[0], 2),
      firstKey = _Object$entries$[0],
      firstValue = _Object$entries$[1];
    rv = "".concat(firstKey, ": ").concat(firstValue);
  }
  return rv;
}

/**
 * feature에 따라 해당 마켓을 지원하는지 여부를 반환합니다.
 * 
 * @param {string} webToken
 * @param {string} feature 지원 여부를 확인한 feature (FEATURE_ENUM)
 * @returns {boolean} 해당 마켓을 지원하는지 여부
 */
function isSupportedMarket(webToken, feature) {
  var PAYMENT_SUPPORTED_MARKET = [MARKET_ENUM.KRPC, MARKET_ENUM.JPPC, MARKET_ENUM.ARENA];
  var PURCHASE_HISTORY_SUPPORTED_MARKET = [MARKET_ENUM.JPPC];
  var market = getMarketFromWebToken(webToken);
  if (feature === FEATURE_ENUM.PAYMENT) {
    return PAYMENT_SUPPORTED_MARKET.includes(market);
  }
  if (feature === FEATURE_ENUM.PURCHASE_HISTORY) {
    return PURCHASE_HISTORY_SUPPORTED_MARKET.includes(market);
  }
  return false;
}

/**
 * 전달받은 Locale을 파싱하여 {language}-{region} 형태로 반환합니다.
 */
function parseLocale() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  try {
    var localeStr = typeof locale === 'string' ? locale.replace('_', '-') : navigator.language;
    var intl = new Intl.Locale(localeStr);
    var _intl$maximize = intl.maximize(),
      language = _intl$maximize.language,
      region = _intl$maximize.region;
    return "".concat(language, "-").concat(region);
  } catch (error) {
    console.warn('[parseLocale] error', error);
    return 'ko-KR';
  }
}
var inpayLocale = {
  FEATURE_ENUM: FEATURE_ENUM,
  MARKET_ENUM: MARKET_ENUM,
  getLocale: getLocale,
  getCurrency: getCurrency,
  getPriceUnit: getPriceUnit,
  getDefaultLocale: getDefaultLocale,
  getLocalizedPrice: getLocalizedPrice,
  getFallbackLocale: getFallbackLocale,
  getMarketFromWebToken: getMarketFromWebToken,
  getLocalizedValue: getLocalizedValue,
  parseLocale: parseLocale,
  isSupportedMarket: isSupportedMarket
};
export default inpayLocale;